<template>
  <div class="coupon-container">
    <div
      v-for="(item, index) in dealCouponBatchList"
      :key="index"
      class="coupon-list"
      :class="{'coupon-list-status-bg': item.couponStatus===1 || item.couponStatus===5}"
    >
    <CouponStatus :couponStatus="item.couponStatus"/>
      <p
        class="discount"
        v-html="item.amountTemplate"
        v-if="+item.couponType === AMOUNT"
      ></p>
      <p class="discount" v-if="+item.couponType === DISCOUNT">
        {{ item.discountOffText }}{{$t('FoodC_C_Off_fkZy')}}
      </p>
      <div class="coupon-desc">{{ getCouponDesc(item)}}</div>
    </div>
  </div>
</template>
<script>
import CouponStatus from './couponStatus.vue'
export default {
  name: 'CouponComponents',
  props: ['couponBatchList'],
  components: {
    CouponStatus
  },
  data () {
    return {
      DISCOUNT: 100, // 折扣券
      AMOUNT: 3 // 满减券
    }
  },
  computed: {
    dealCouponBatchList () {
      return this.couponBatchList.map((coupon) => ({
        amountTemplate: this.amountTemplate({
          split: {
            number: coupon.couponAmountSplit.number,
            symbol: coupon.couponAmountSplit.symbol,
            position: coupon.couponAmountSplit.position
          },
          clsSymbol: 'money-symbol',
          clsNumber: 'money-number'
        }),
        ...coupon
      }))
    }
  },

  methods: {
    amountTemplate (data) {
      let resTemplate = ''
      if (data) {
        const { split, clsSymbol, clsNumber } = data
        if (split) {
          const { number, symbol, position } = split // position 货币符号位置 0 货币符号在前 1 货币符号在后
          const symbolFirst = `<span class="${clsSymbol}">${symbol}</span><span class="${clsNumber}">${number}</span>`
          const numberFirst = `<span class="${clsNumber}">${number}</span><span class="${clsSymbol}">${symbol}</span>`
          resTemplate = +position === 0 ? symbolFirst : numberFirst
        }
      }
      return resTemplate
    },
    getCouponDesc (val) {
      // 如果是
      if (val.couponType === this.AMOUNT) {
        let moneyText = val.minCostSplit.display
        return val.minCostSplit.number != 0 ? this.$t('FoodC_C_Full_money_oqcE', {money: moneyText}) : this.$t('FoodC_419_zBRR_jLNF') // eslint-disable-line
      } else if (val.couponType === this.DISCOUNT) {
        let moneyText = val.couponAmountSplit.display
        return this.$t('FoodC_C_Maximum_deduction_UvNt', {money: moneyText})
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/var.scss";

.coupon-container {
  margin: 0 40px 16px 40px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  .coupon-list {
    width: 326px;
    height: 164px;
    border-radius: 8px;
    margin-bottom: 24px;
    position: relative;
    @include new-coupon-bg();
  }
  .coupon-list-status-bg {
    filter: grayscale(100%);
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
  }
  .coupon-list:after {
    position: absolute;
    content: "";
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 100%;
    right: 0;
    top: 50%;
    transform: translate(50%, -50%);
  }

  .coupon-list:before {
    position: absolute;
    content: "";
    width: 18px;
    height: 18px;
    background: #fff;
    border-radius: 100%;
    left: 0;
    top: 50%;
    transform: translate(-50%, -50%);
  }
  .discount {
    width: 88%;
    margin: 36px auto 10px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
    font-family: "Aspira Medium";
    font-size: 60px;
    font-weight: 500;
    @include font-color();
    ::v-deep .money-symbol {
      font-family: "Aspira Medium";
      font-size: 24px;
      font-weight: 500;
      margin-right: 4px;
    }
    ::v-deep .money-number {
      font-family: "Aspira Medium";
      font-size: 60px;
      font-weight: 500;
      margin-right: 4px;
    }
  }
  .coupon-desc {
    @include font-color();
    width: 88%;
    margin: 0 auto;
    height: 22px;
    font-family: "Aspira Light";
    font-size: 22px;
    text-align: center;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    text-align: center;
  }
}
</style>
